import React, {useEffect, useState} from "react";
import {api} from "../utils/gashtaltAPI";
import Loader from "../components/Loader";
import ErrorPage from "../components/ErrorPage";
import Navbar from "../components/Navbar";
import {Table, TableContainer, Tbody, Td, Thead, Tr} from "@chakra-ui/react";
import {toPersianNumber} from "../utils/numberConversion";
import {useNavigate, useParams} from "react-router-dom";
import FilterTd from "../components/FilterTd";
import DownloadHandler from "../utils/downloadHandler";
import {RiFileExcel2Line} from "react-icons/ri";

function Results(){
    const {examId} = useParams()
    const [params,setParams] = useState({examId})
    const [exams, setExams] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [startIndex, setStartIndex] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [error, setError] = useState(null);
    const [loading,setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get(`/api/exam/results/all?page=${currentPage}`,{
                    params : params
                })
                const result = response.data.data
                setExams(result.data);
                setStartIndex(result.from);
                setLastPage(result.last_page);
            } catch (error) {
                setError(error)
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [params,currentPage]);

    const handleNextPage = () => {
        if (currentPage < lastPage) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };
    if (loading) return <Loader />
    if (error) return <ErrorPage error={error}/>;
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="table-container flex-fill d-flex flex-column justify-content-between"
                 style={{borderTop: '3px solid #EAEAEA'}}>
                <TableContainer>
                    <Table variant='striped' colorScheme='teal'>
                        <Thead>
                            <Tr>
                                <Td>ردیف</Td>
                                <Td>
                                    <FilterTd
                                        name={"نام و نام خانوادگی"}
                                        defaultValue={params.name}
                                        onSubmit={(value) => {
                                            //setCurrentPage(1);
                                            setParams((prevFilters) => ({
                                                ...prevFilters,
                                                name: value,
                                            }));
                                        }}
                                        onCancel={() => {
                                            //setCurrentPage(1);
                                            setParams((prevFilters) => {
                                                const { name, ...rest } = prevFilters;
                                                return rest;
                                            });
                                        }}
                                    />
                                </Td>
                                <Td>آزمون</Td>
                                <Td>کارنامه</Td>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {exams.map((exam, index) => (
                                <Tr>
                                    <Td>{toPersianNumber(index + 1)}</Td>
                                    <Td>{exam.user_name}</Td>
                                    <Td>{exam.exam_name}</Td>
                                    <Td>
                                        <button
                                            className={`btn btn-outline-green`}
                                            onClick={() => {
                                                navigate(`/ResultById/${exam.user_id}/${exam.exam_id}`)
                                            }}>
                                            نمایش
                                        </button>
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>
            <div className="py-2 d-flex justify-content-center gap-3">
                <button
                    className={`btn btn-outline-orange`}
                    disabled={1 === currentPage}
                    onClick={() => {
                        setCurrentPage(1)
                    }}
                >
                    صفحه اول
                </button>
                <button
                    className={`btn btn-outline-blue`}
                    disabled={currentPage === 1}
                    onClick={handlePrevPage}
                >
                    صفحه قبل
                </button>
                <button
                    className={`btn btn-outline-blue`}
                    disabled={lastPage === currentPage}
                    onClick={handleNextPage}
                >
                    صفحه بعد
                </button>
                <button
                    className={`btn btn-outline-orange`}
                    disabled={lastPage === currentPage}
                    onClick={() => {
                        setCurrentPage(lastPage)
                    }}
                >
                    صفحه آخر
                </button>
                <button
                    className={`btn btn-outline-green d-flex align-items-center gap-1`}
                    disabled={lastPage === currentPage}
                    onClick={() => {
                        DownloadHandler()
                    }}
                >
                    <RiFileExcel2Line style={{fontSize: '1.1rem'}}/>
                    خروجی اکسل
                </button>
            </div>
        </div>
    );
}

export default Results;